export const MOVIE = 'movie';
export const SHOW = 'series';

export const toContentTypeLabel = titleType => {
  let contentType = '';
  if (titleType === MOVIE) {
    contentType = 'Movies';
  } else if (titleType === SHOW) {
    contentType = 'Shows';
  } else {
    contentType = 'All';
  }
  return contentType;
};
